import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=7f70a3cd&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=7f70a3cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f70a3cd",
  null
  
)

export default component.exports